import React from 'react'
import PropTypes from 'prop-types'
import { DesktopDateRangePicker } from '@mui/x-date-pickers-pro/DesktopDateRangePicker'
import { Controller } from 'react-hook-form'
import { Box, FormHelperText } from '@mui/material'
import noop from 'lodash/noop'
import StyledPickersTextField from './StyledPickersTextField'
import { MultiInputDateRangeField } from '@mui/x-date-pickers-pro'

const HHDateRangePicker = ({ control, name, rules, error = false, helperText = '', readOnly = false, onChange = noop, ...rest }) => {
  return (
    <Controller
      rules={rules}
      control={control}
      name={name}
      render={({ field }) => {
        const handleChange = value => {
          field.onChange(value)
          onChange(value)
        }
        return (
          <Box>
            <DesktopDateRangePicker
              readOnly={readOnly}
              value={field.value || [null, null]}
              {...rest}
              onChange={handleChange}
              slots={{ textField: StyledPickersTextField, field: MultiInputDateRangeField }}
              slotProps={{
                textField: ({ position }) => ({
                  error,
                  fullWidth: true,
                }),
                fieldSeparator: { display: 'none' },
              }}
            />
            <FormHelperText sx={{ marginX: '14px' }} error={error}>
              {helperText}
            </FormHelperText>
          </Box>
        )
      }}
    />
  )
}

HHDateRangePicker.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  error: PropTypes.bool,
  rules: PropTypes.object,
  helperText: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
}

export default HHDateRangePicker
